import { useEffect, useRef, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../hooks/redux"
import { StoryDay, StoryItem, StoryType } from "../../models/commonModels"
import { LentaItem } from "./components/LentaItem/LentaItem"
import { getStoryPage, remooveStorys, sendReaction, setCommentStory, setPageUp } from "../../store/lenta-slice/LentaSlice"
import { LentaDate } from "./components/LentaItem/LentaDate"
import { Preloader } from "../../components/preloader/preloader"
import { useNavigate } from "react-router-dom"
import styles from './LentaPage.module.css'
import refresh from './../../image/ic_refresh.svg'
import search from './../../image/ic_search.svg'
import close from './../../image/ic_close_svg.svg'
import { CommentView } from "./components/CommentView/CommentView"
import { CommentPage } from "../CommentPage/CommentPage"
import { Input } from 'antd';
import type { GetProps } from 'antd';
export const LentaPage = () =>{
    const dispatch:any = useAppDispatch() 
    const storyItem:StoryDay[] = useAppSelector(state=>state.lentaStore.storys)
    const page:number = useAppSelector(state=>state.lentaStore.page)
    const token = useAppSelector(state=>state.appStore.token)
    const lentaCardList = useRef<HTMLDivElement|null>(null)
    const hasMore = useAppSelector(state=>state.lentaStore.hasMore)
    const onLoad = useAppSelector(state=>state.lentaStore.isLoad)
    const commentItem = useAppSelector(state=>state.lentaStore.commentStory)
    const [commentPageVisible,setCommentPageVisible]=useState(false)
    const [Height,setHeight] = useState(0)
    const [pageScroll,setpageScroll] = useState(0)
    const navigation = useNavigate();
    const [isSearch,setIsSearch]=useState(false)
    const[x,setX] = useState(0)
    const[y,setY] = useState(0)
    const [startYOffser, setStartYOffser] = useState(0)
    const { Search } = Input;
    const [searchText,setSearchText]=useState("")
    useEffect(()=>{
        dispatch(remooveStorys())
        window.addEventListener('scroll', handleScroll, true);
        return ()=>window.removeEventListener('scroll', handleScroll,true)
    },[])
    
    useEffect(()=>{
        if(token==null)return
        if(hasMore)dispatch(getStoryPage(page,token?.token,searchText.length>0?searchText:null))
    },[page,hasMore,token])

    function comparison(pageHeight:number, scrolled:number) {
        setHeight(pageHeight)
        setpageScroll(scrolled)
    let check = [
         Math.round(scrolled) + 1,
        Math.round(scrolled),
        Math.round(scrolled) - 1,
    ];

    return check.includes(pageHeight) ? true : false;
}

    const handleScroll = () =>{
        if(lentaCardList.current){
            setStartYOffser(lentaCardList.current.scrollTop)
            console.log('1',lentaCardList.current.offsetHeight)
            console.log('2',lentaCardList.current.scrollHeight)
            console.log('3',lentaCardList.current.scrollTop)
            if(!comparison(lentaCardList.current.scrollHeight,lentaCardList.current.offsetHeight+lentaCardList.current.scrollTop)||!hasMore||lentaCardList.current.scrollTop===0){
                return
            }
        }else{
            return
        }
        dispatch(setPageUp())
    }

    const refreshEvent=()=>{
        if(page==0){
            dispatch(remooveStorys());
            if(token==null)return
            dispatch(getStoryPage(page,token.token))
        }else{
            dispatch(remooveStorys());
        }
    }
    type SearchProps = GetProps<typeof Input.Search>;
    const onSearch: SearchProps['onSearch'] = (value, _e, info) => searchUserStory(value);
    const searchUserStory = (text:string) =>{
        setSearchText(text)
        dispatch(remooveStorys())
        if(token==null)return
        if(page===0&&text.length>0)dispatch(getStoryPage(page,token?.token,text.length>0?text:null))
    }
    return(
        <>
        {commentPageVisible&&<CommentPage onClose={()=>{setCommentPageVisible(false)
            dispatch(setCommentStory(null))}}/>}
        <div ref={lentaCardList} style={{display:commentPageVisible?"none":"flex", flexDirection:"column", gap:"10px",overflow:"auto", padding:"0px"}} >
            {onLoad&&<Preloader/>}
            <div className={styles.lenta_search_bar_container} >
                {!isSearch?<img src={search} onClick={()=>setIsSearch(true)}/>:<img src={close} onClick={()=>{setIsSearch(false); setSearchText("");refreshEvent()}}/>}
                {!isSearch?<img src={refresh} onClick={()=>refreshEvent()} />:<Search placeholder="Имя Фамилия" onSearch={onSearch} />}
            </div>
            {commentItem&&<CommentView commentPageVisible={commentPageVisible} onCommentClick={()=>setCommentPageVisible(true)} x={x} y={y} onClose={()=>{dispatch(setCommentStory(null))}} startYOffser={startYOffser} commentItem={commentItem}/>}
            {storyItem.map((item)=>{return(
                <LentaDate text={item.activity_date} dayWeek={item.weekday}>
                <div style={{display:"flex", gap:"10px", flexDirection:"column"}}>
                    {item.activity_date_list.map((itemList)=>
                    {return(
                    <LentaItem 
                        act_type={itemList.act_type}
                        uId={itemList.u_id}
                        photo={itemList.photo}
                        image={itemList.images}
                        name={itemList.user_name} 
                        distance={itemList.distance}
                        time={itemList.time}
                        reactions={itemList.emojis_list}
                        contComment={itemList.count_comment==null?0:itemList.count_comment}
                        distance_day={itemList.distance_day} onCommentClick={(x,y)=>{
                            if(lentaCardList.current!=null){
                                setY(lentaCardList.current.scrollTop+y-(lentaCardList.current.offsetTop))
                            }
                            setX(50)
                            dispatch(setCommentStory(itemList))
                        }}/>)})}
                </div>
            </LentaDate>)})}
        </div>
        </>
    )
}